var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-card',{staticStyle:{"margin-bottom":"16px","border-radius":"16px"},attrs:{"bordered":false,"bodyStyle":{ padding: '18px 22px' }}},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }